import i18n from "../i18n";

if (localStorage.Lang != null)
  i18n.locale = localStorage.Lang;

export default { /* This needs to be removed and put into the api with NO html */
    teamInformation: 
        `<p>Servicers that work with the client but do not fall in these 4 categories will need to be added in BP directly.</p>
        <ul>
            <li><b>Administrator</b>: Select the servicer that is ultimately accountable for the group.</li>
            <li><b>Primary Sales Lead</b>: Select the producer responsible for this Client.</li>
            <li><b>Primary Service Lead</b>: Select the servicer that is ultimately accountable for the group.</li>
            <li><b>Primary Contact</b>: Select the servicer that will be the clients day to day contact.</li>
        </ul>`,

    clientPrimaryContact: `Your day to day contact at the client. All other Client contacts will need to be added in BP.`,

    marketSize: 
        `Large (250+)<br />
        Medium (100-250)<br />
        Middle (51-99)<br />
        Small (1-50)<br />`,
        
    require5000: 'All Clients with 100 enrolled employees will need to file a 5500 annually',

    effectiveDates: `Effective date = the date your plan/policy takes effect<br />Renewal date = the date the plan/policy renews`,
    billingType: `Agency bill = HUB generates a bill in EPIC to Client<br />Direct bill = Carrier generates a bill direct to Client`,
    cancellationInformationTooltip: `If you want to cancel this plan, please specify reason and date`,
    // NOTE newBusinessUntilTooltip uses JS to get today's date so we'll lose that feature if we move this file to be API-driven
    newBusinessUntilTooltip: `12 months from the original date we started receiving commission (i.e. effective date: ${("0" + (new Date().getMonth()+1)).slice(-2)}/${("0" + new Date().getDate()).slice(-2)}/${new Date().getFullYear()}, NBU date: ${("0" + (new Date().getMonth()+1)).slice(-2)}/${new Date().getFullYear()+1})`,
    sameAsAddress: `Same as Main Address.`,
    generalNames: `
    <ul>
        <li>Tier 1: Generic</li>
        <li>Tier 2: Brand</li>
        <li>Tier 3: NF Brand</li>
        <li>Tier 4: Preferred Specialty</li>
    </ul>
    `,
    phoneNumberToolTip(bpBaseUrl){ 
        return `If there is a need to add Mobile/Fax/Other numbers, Please add them in <a href="${bpBaseUrl}" target="_blank">Benefit Point</a>&nbsp;<a href=""><i class="fas fa-link"></i></a>.`
    },
    originalCoreToolTip(value) {
      return i18n.t("OriginalCoreValue", {0: value});
    },
    sicCode: 'Search for SIC Code by keyword or up-to 4 digit code'
}
